import apiClient from "./axiosInstanceOrder";

export const getSellerRevenueSummary = async (ownerid) => {
  return await apiClient.get(`/v1/orders/seller/${ownerid}/revenue`);
};

export const createOrder = async (orderData) => {
  return await apiClient.post("/v1/orders/upsert", orderData);
};

export const getOrderById = async (id) => {
  return await apiClient.get(`/v1/orderdetails/${id}`);
};

export const getOrdersByBuyerId = async (buyerid) => {
  return await apiClient.get(`/v1/orders/orderdetailsbyBuyerId/${buyerid}`);
};

export const getOrdersByBoatOwner = async (ownerid) => {
  return await apiClient.get(`/v1/orders/orderdetailsbyboatowner/${ownerid}`);
};

export const getOrderSummaryByBoatOwner = async (ownerid) => {
  return await apiClient.get(`/v1/orders/getsellerordersummary/${ownerid}`);
};

export const getSalesData = async (ownerid, year) => {
  return await apiClient.get(`/v1/orders/getsalesdata/${ownerid}/${year}`);
};

export const getMontlyRevenue = async (ownerid, year) => {
  return await apiClient.get(`/v1/orders/getMonthlyRevenue/${ownerid}/${year}`);
};

export const getOrdersByVessel = async (imul_number) => {
  return await apiClient.get(`/v1/getordersbyvessel/${imul_number}`);
}

export const getOrdersByProccesingPlantId = async (plantId) => {
  return await apiClient.get(`/v1/getordersbyplant/${plantId}`);
}

export const getOrderCountByBoatOwnerId = async (id) => {
  return await apiClient.get(`/getOrderCountByBoatOwnerId/${id}`);
};

export const getOrdersByCourierId = async (id) => {
  return await apiClient.get(`/v1/getordersbycourier/${id}`);
};





